export const parseStyles = (styles: string) => {
    const style: Record<string, string> = {}
    if (!styles) return style
    styles.split(';').forEach((s) => {
        const [key, value] = s.split(':')
        if (key && value) {
            style[key.trim()] = value.trim()
        }
    })
    return style
}

export const stylesToString = (styles: Record<string, string>) => {
    const style: Array<string> = []
    Object.keys(styles).forEach((key) => {
        style.push(`${key}:${styles[key]}`)
    })
    if (style.length === 0) return ''
    return style.join(';') + ';'
}
